import React, { useEffect, useState } from 'react';
import { Link, Navigate, Outlet } from 'react-router-dom';
import { useUser } from '../../auth/UseUser';
import NavBar from '../NavBar';
import SideBarBigScreen from '../SideBarBigScreen';
import NavigationBar from '../NavigationBar';
import UserHome from '../user/UserHome';

function Layout() {
    const { isSignedIn, isAdminApp } = useUser();
    const [isOpen, setIsopen] = useState(false);

    const toggleSidebar = () => {
        console.log('toggle');
        isOpen === true ? setIsopen(false) : setIsopen(true);
    };
    useEffect(() => {
        console.log('i am here : ', isSignedIn);
    }, []);

    return (
        <div className="bg-basicBackground h-screen ">
            <div className=" w-full h-full">
                {isSignedIn && <NavBar toggleSideBar={toggleSidebar} />}
                {/* {!isAdminApp && <UserHome />} */}
                {isAdminApp && (
                    <div className=" w-full h-[calc(100%-70px)]">
                        <div className={` flex flex-row h-full  relative`}>
                            <SideBarBigScreen toggleSideBar={toggleSidebar} isOpen={isOpen} backbutton={true} />
                            <div className="bg-gold flex-1 h-full overflow-auto">
                                {/* An <Outlet> renders whatever child route is currently active,
          so you can think about this <Outlet> as a placeholder for
        the child routes we defined above. */}

                                <Outlet />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Layout;
